<template>
  <div class="container-dashboard-v3"   v-bind:class="{'run-loading':loadingData}">
      <div class="container-dashboard-content" v-if="loadingData==false">
        <div class="content" v-if="master.contract_id">
          <b-container fluid>
            <b-row>
              <b-col>
                <div class="dashboard-toolbar">
                  <svg @click="openFilterPopup" xmlns="http://www.w3.org/2000/svg" width="20" height="20"  fill="currentColor" class="bi bi-filter filter-link" viewBox="0 0 16 16">
                    <title>Filter</title>
                    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
                  </svg>
                </div>
                <b-card class="v3-filter-card">
                  Date : {{display_start_date}} to {{display_end_date}}
                </b-card>
                <b-card class="v3-filter-card">
                  Property : {{display_property_name}}
                </b-card>
                <b-card class="v3-filter-card">
                  Service Category : {{display_service_category_name}}
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" v-for="mp_item in master.maintenance_programs">
                <b-row class="v3-card-label-div">
                  <h6>{{mp_item.description_one}}</h6>
                </b-row>
                <b-card class="v3-card">
                  <b-card-header>
                    Overall Job Completion
                  </b-card-header>
                  <b-card-body class="chart-div">
                    <div :id="'jobCompleteGaugeChart'+mp_item.id">
                    </div>
                  </b-card-body>
                </b-card>
                <b-card class="v3-card">
                  <b-card-header>
                      Job Status
                  </b-card-header>
                  <b-card-body class="chart-div">
                    <div :id="'jobStatusBarChart'+mp_item.id">
                    </div>
                  </b-card-body>
                </b-card>
                <!-- <b-card  class="v3-card">
                  <b-card-header>
                      Job Completion
                  </b-card-header>
                  <b-card-body class="chart-div">
                    <div :id="'jobCompletionBarChart'+mp_item.id">
                    </div>
                  </b-card-body>
                </b-card> -->
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="no-contract" v-if="!master.contract_id">
          <div class="child">Please choose a contract to load the dashboard.</div>
        </div>
      </div>
        <b-modal id="modal-Filter" title="Filters" hide-footer :centered="true" v-model="modals.filter.open">
            <b-form>
                <b-row>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.filter.data.start_date"
                            label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.filter.data.end_date"
                            label="End Date">
                        </gofix-form-input-date>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <div class="property-tree">
                      <gofix-form-properties
                              label="Select Property"
                              :contract-id="master.contract_id"
                              :property-id="master.root_property_id"
                              valueFormat="object"
                              v-model="modals.filter.data.property"
                              >
                      </gofix-form-properties>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <div class="property-tree">
                      <gofix-form-tree
                          label="Service Category"
                          :default-expand-level="0"
                          :multiple="false"
                          :options="dataService"
                          :load-options="loadOptionsService"
                          :normalizer="normalizerService"
                          search-nested
                          valueFormat="object"
                          v-model="modals.filter.data.service_category"
                          placeholder="Select"
                          ref="input">
                      </gofix-form-tree>
                    </div>
                  </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" :loading="modals.filter.loading" @click="applyFilter" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {LOAD_CHILDREN_OPTIONS} from '@riophae/vue-treeselect';
const tile = () => import('./dashboard-six-monthly-safety/tile.vue');
import moment from 'moment';
import c3 from 'c3';
import * as d3 from 'd3'
const _ = require('lodash');
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500);
};

  export default {
    components: {
      tile,
    },
    data: function() {
      return {
        loadingData: true,
        pm1_chart_colors: {
            PLANNED: '#6b007b',
            DUE: '#e66c37',
            EXPIRED: '#12239e',
            VERIFIED: '#62b3fc',
            ENDORSED: '#b1c1fc',
            COMPLETED: '#118dff',
            CANCELLED: '#fc9b56',
            INACTIVE: '#5d6363',
            STARTED: '#b1fbfc',
            END: '#fcfbb1',
            CLOSED: '#62b3fc',
            "RWO ISSUED": '#1aab40',
            "REPEATED FEEDBACK":"#197278",
            ASSIGNED:"#20a8d8",
            APPROVED:"#12239e",
            DISPATCHED:"#d9b300",
            INVOICED:"#d64550",
            ISSUED:"#197278",
            total: '#000000',
            "PIC ACKNOWLEDGED": '#d64550',
            OPEN: '#d9b300',
            "ON SITE": '#15c6f4',
            "PENDING REVISION": '#ffa058',
            "REJECTED":'#f472d0',
            "UNDER APPROVAL": '#b5a1ff',
            "PENDING-PARTS":'#be5dc9',
            "ON-SITE":'#15c6f4',
            "ONSITE": '#15c6f4',
            "PARTIALLY COMPLETED": '#4092ff',

        },
        pm2_chart_colors: {
          COMPLETED: '#118dff',
          UNCOMPLETED: '#12239e'
        },
        master: {
          contract_id: 0,
          root_property_id: 0,
          root_service_category_id: 0,
          tableItems: [],
          data: {
            job: {},
            issue_register: [],
            jobCompletion: [],
            jobCompletionPercent: 0,
            maintenance_programs: [],
          },
          filter: {
            start_date: null,
            end_date: null,
            property: null,
            service_category: null,
          },
        },
        init: true,
        modals: {
          filter: {
            open: false,
            loading: false,
            data: {
              start_date: null,
              end_date: null,
              property: null,
              service_category: null,
            }
          },
        },
        dataService: [],
        charts: {
          chart1:null,
          chart2:null,
          chart3:null,
          chart4:null,
          chart5:null,
          chart6:null,
        },
      }
    },

    async created() {
        if(this.ClientContractID && this.ClientContractID.contract_terms){
            this.loadingData = true;
            this.master.contract_id = this.ClientContractID.id;
            this.master.contract_term_id = this.ClientContractID.contract_terms[0].id;
            this.checkToRedirectToSixMonthly();
            this.loadRootProperty();
        }
        else{
          this.loadingData = false;
          this.master.contract_id = null;
          this.master.contract_term_id = null;
        }
    },

    async mounted() {   
    },

    computed: { 
      ...mapGetters({
        ClientContractID: 'ContractController/ClientContractID',
        UserLogin: "AuthController/user",
      }),
      display_start_date() {
        if(this.master.filter.start_date)
          return moment(this.master.filter.start_date).format('DD-MM-YYYY');
      },
      display_end_date() {
        if(this.master.filter.end_date)
          return moment(this.master.filter.end_date).format('DD-MM-YYYY');
      },
      display_property_name() {
        if(this.master.filter.property && this.master.filter.property.name)
          return this.master.filter.property.name;
      },
      display_service_category_name() {
        if(this.master.filter.service_category && this.master.filter.service_category.name)
          return this.master.filter.service_category.name;
      },
    },

    methods: {
      ...mapActions({
            getItems: 'DashboardV3Controller/getItems',
        }), 
      async getDashboardV3Data() {
        if(this.master.contract_id && this.master.contract_term_id){

          let filters = {
              search:             null,
              contract_term_id:   this.master.contract_term_id,
              is_maintenance:     true,
              //is_master:          false,
              //recurring_mode_one_and_five_year: true
          };

          await this.$store.dispatch("v2SorController/getItems", {
                    isCMS: false,
                    page: -1,
                    limit: 100,
                    group_id: 0,
                    filter: filters
                })
                .then(async sor_response => {

                  if(sor_response.items && sor_response.items.length == 0){
                    this.loadingData = false;
                    console.log("Dashboard error: No maintenance programs found.");
                    this.master.maintenance_programs = [];
                    if(this.master.filter.start_date == null){
                      var enddate = moment().clone().endOf("month")
                      var startdate = moment().clone().startOf('month');
                      this.master.filter.start_date = startdate.toDate();
                      this.master.filter.end_date = enddate.toDate();
                      
                      this.modals.filter.data.start_date = this.master.filter.start_date;
                      this.modals.filter.data.end_date = this.master.filter.end_date;
                    }
                    return;
                  }

                  var lift_mps = _.filter(sor_response.items, function(item) { return item.description_one && item.description_one.toLowerCase().includes('lift'); });
                  if(lift_mps && lift_mps.length > 0){
                    this.master.maintenance_programs = lift_mps;
                  }
                  else {
                    this.master.maintenance_programs = sor_response.items;
                  }

                    //this.master.maintenance_programs = sor_response.items;
                    var params={};

                    for (const mp_item of this.master.maintenance_programs) {

                      if(this.master.filter.start_date == null){
                      var enddate = moment().clone().endOf("month")
                      var startdate = moment().clone().startOf('month');
                      this.master.filter.start_date = startdate.toDate();
                      this.master.filter.end_date = enddate.toDate();
                      
                      this.modals.filter.data.start_date = this.master.filter.start_date;
                      this.modals.filter.data.end_date = this.master.filter.end_date;
                    }

                    params.client_contract_id = this.master.contract_id;
                    params.property_id = this.master.filter.property.id;
                    params.start_date = moment(this.master.filter.start_date).format('YYYY-MM-DD');
                    params.end_date = moment(this.master.filter.end_date).format('YYYY-MM-DD');
                    params.service_category_id = this.master.filter.service_category.id;
                    params.maintenance_program_id = mp_item.id;

                    this.loadingData = false;

                    var height = window.innerHeight * 0.32;
                    if(height<125){
                      height =125;
                    }

                    //this.loadLoadingCharts(height);
                    
                    //1.completed_job
                    params.data_key = 'fm_completed_job';
                    await this.getItems(params)
                        .then(response => {
                            var data = {};
                            
                            data.height = height;

                            if(response.completed_job){
                              var completed_count = 0;
                              var uncompleted_count = 0;
                              response.completed_job.forEach(job => {
                                if(job.job_status=='COMPLETED'){
                                  completed_count = job.count;
                                }
                                else {
                                  uncompleted_count = job.count;
                                }
                              });
                              var sum = completed_count + uncompleted_count;
                              var percent = ((completed_count / sum) * 100).toFixed(2);
                              
                              data.completed_job_percent = percent;
                              data.completed_count = completed_count;
                              data.uncompleted_count = uncompleted_count;
                              data.total = sum;
                              data.maintenance_program_id = params.maintenance_program_id;
                            }
                            
                            let that = this;
                            setTimeout(function (data){
                              that.loadJobsGaugeChart(data);
                            }, 100,data);
                        })
                        .catch(err => {
                            console.log(err);
                            let that = this;
                            setTimeout(function (id,height){
                              that.showNoDataChart(id,height);
                            }, 100,'#jobCompleteGaugeChart1',height);
                        });

                    //2.job
                    params.data_key = 'fm_job';

                    await this.getItems(params)
                        .then(response => {
                            var data = {};
                            data.height = height;

                            if(response.job){
                              data.original = response.job;
                              const unique_status = _.map(_.uniqBy(response.job, (obj) => obj.job_status),'job_status');
                              const unique_category = _.map(_.uniqBy(response.job, (obj) => obj.service_category),'service_category');
                              data.status = unique_status;
                              data.category = unique_category;

                              const category_status= [];
                              _.map(response.job,function (o){ 
                                if(category_status[o.service_category]){
                                  category_status[o.service_category].push(o.job_status);
                                }else{
                                  category_status[o.service_category]=[];
                                  category_status[o.service_category].push(o.job_status);
                                }
                              });
                              data.category_status = category_status;
                              
                              var all_status_count = [];
                              unique_status.forEach(status => {
                                var status_count = [];
                                status_count.push(status);
                                unique_category.forEach(category => {
                                  var obj_to_locate = { 'service_category': category, 'job_status': status };
                                  const result = _.find(response.job, obj_to_locate);
                                  if(result)
                                    status_count.push(result.count);
                                  else 
                                    status_count.push(0);
                                });
                                all_status_count.push(status_count);
                              });
                              data.all_status_count=all_status_count;
                              data.maintenance_program_id = params.maintenance_program_id;
                            }
                        
                            let that = this;
                            setTimeout(function (data){
                              that.loadVerticalStackBarChart('#jobStatusBarChart'+data.maintenance_program_id,data,'service_category','job_status');
                            }, 100,data);
                        })
                        .catch(err => {
                            console.log(err);
                            let that = this;
                            setTimeout(function (id,height){
                              that.showNoDataChart(id,height);
                            }, 100,'#jobStatusBarChart2',height);
                        });


                    // //3.assign_completed_job
                    // params.data_key = 'fm_assign_completed_job';
                    // await this.getItems(params)
                    //     .then(response => {
                    //         var data = {};
                    //         data.height = height;

                    //         if(response.assign_completed_job){
                    //           data.original = response.assign_completed_job;
                    //           const unique_status = ['COMPLETED','UNCOMPLETED']
                    //           const unique_assign = _.map(_.uniqBy(response.assign_completed_job, (obj) => obj.assign),'assign');
                    //           data.status=unique_status;
                    //           data.category = unique_assign;
                              
                    //           var all_status_count = [];
                    //           unique_status.forEach(status => {
                    //             var status_count = [];
                    //             status_count.push(status);
                    //             unique_assign.forEach(category => {
                    //               var obj_to_locate = { 'assign': category, 'job_status': status };
                    //               const result = _.find(response.assign_completed_job, obj_to_locate);
                    //               if(result)
                    //                 status_count.push(result.count);
                    //               else 
                    //                 status_count.push(0);
                    //             });
                    //             all_status_count.push(status_count);
                    //           });
                    //           data.pm2_all_status_count=all_status_count;
                    //           data.maintenance_program_id = params.maintenance_program_id;
                    //         }
                            
                    //         let that = this;
                    //         setTimeout(function (data){
                    //           that.loadHorizontalStackBarChart('#jobCompletionBarChart'+data.maintenance_program_id,data,'assign','job_status');
                    //         }, 100,data);
                    //     })
                    //     .catch(err => {
                    //         console.log(err);
                    //         let that = this;
                    //         setTimeout(function (id,height){
                    //           that.showNoDataChart(id,height);
                    //         }, 100,'#jobCompletionBarChart3',height);
                    //     });
                    }
                });



        }
      },  
      async loadRootProperty(){
            await global.axios(`api/contracts/${this.master.contract_id}/tree-properties/0`, {
                method: "GET",
                data: {},
                headers: {
                    Accept: "application/json",
                }
            })
            .then(result => {
                this.master.root_property_id = result.data.data[0].id;
                this.master.filter.property = { id: result.data.data[0].id, name: result.data.data[0].name };
                this.modals.filter.data.property = { id: result.data.data[0].id, name: result.data.data[0].name };
                this.loadRootServiceCategory();
                
            })
            .catch(error => {
                console.log(error);
                this.init = false;
            });
      },
      loadRootServiceCategory() {
          global.axios(`api/contracts/${this.master.contract_id}/tree-service-categories/0`, {
                  method: "GET",
                  headers: {
                      Accept: "application/json",
                  }
              })
              .then(result => {
                  this.master.root_service_category_id = result.data.data[0].id;
                  this.master.filter.service_category = { id: result.data.data[0].id, name: result.data.data[0].name };
                  this.modals.filter.data.service_category = { id: result.data.data[0].id, name: result.data.data[0].name };
                  this.getDataService(result.data.data[0].id,'all',true);
                  this.getDashboardV3Data();
                  this.init = false;
              })
              .catch(error => {
                  console.log(error);
                  this.init = false;
              });
      },
      applyFilter(){
        this.loadingData = true;
        this.modals.filter.open = false;
        this.master.filter.start_date = this.modals.filter.data.start_date;
        this.master.filter.end_date = this.modals.filter.data.end_date;
        this.master.filter.property = this.modals.filter.data.property;
        this.master.filter.service_category = this.modals.filter.data.service_category;
        this.getDashboardV3Data();
      },
      openFilterPopup(){
        this.modals.filter.data.start_date = this.master.filter.start_date;
        this.modals.filter.data.end_date = this.master.filter.end_date;
        this.modals.filter.data.property = this.master.filter.property;
        this.modals.filter.open = true;
      },
      loadLoadingCharts(height){
        let that = this;
        setTimeout(function (height){
          var message = "";
          that.showLoadingMessage('#jobCompleteGaugeChart1',height,message);
          that.showLoadingMessage('#jobStatusBarChart2',height,message);
          that.showLoadingMessage('#jobCompletionBarChart3',height,message);
          that.showLoadingMessage('#pwoBarChart4',height,message);
          that.showLoadingMessage('#RWOBarChart5',height,message);
          that.showLoadingMessage('#CaseBarChart6',height,message);
        }, 100,height);
      },
      loadJobsGaugeChartC3(data){
        var clabel = '';
        if(!isNaN(data.completed_job_percent)){
          var initial = [['Completed Jobs', 0]];
          var width = window.innerWidth * 0.29 * 0.65;
          this.charts.chart1 = c3.generate({
              bindto: '#jobCompleteGaugeChart1',
              data: {
                  columns: initial,
                  type: 'gauge',
                  labels: false,
              },
              gauge: {
                //width:40
                max: data.total,
              },
              color: {
                  pattern: ['#118dff', '#118dff'], // the three color levels for the percentage values.
                  threshold: {
                      unit: 'value',
                      max: data.total,
                      values: [0, data.total]
                  }
              },
              size: {
                height: data.height*0.8,
                width: width
              },
              tooltip: {
                position: function (data, width, height, element) {
                  return {top: 0, left: 125};
                }
              }
          });
          
          setTimeout(function (chart,data) {
              chart.load({
                  columns: [['Completed Jobs', data]]
              });
          }, 100,this.charts.chart1,data.completed_count); 
        }
        else{
          this.showNoDataChart("#jobCompleteGaugeChart1",data.height);
          return;
        }
      },   
      loadJobsGaugeChart(data){
        var clabel = '';
        if(!isNaN(data.completed_job_percent)){
          var initial = [['Completed Jobs', 0]];
          var width = window.innerWidth * 0.29 * 0.85;
          const div_id = "#jobCompleteGaugeChart"+data.maintenance_program_id;
          this.showV3Card(div_id);
          const div = document.querySelector(div_id);
          div.innerHTML ="";
          var height = data.height; 
          var radius = Math.min(width, height) / 2;

          var color = d3.scaleOrdinal()
            .range(['#118dff', '#12239e']);
          
              var chart_data = [
                { label: 'Completed', value: data.completed_count },
                { label: 'Not Completed', value: data.uncompleted_count },
              ];

              this.master.jobCompletion = chart_data;
              data.chart_data= chart_data;
              this.master.jobCompletionPercent = data.completed_job_percent;
              var that = this;

              var vis = d3.select(div_id)
                          .append("svg")             
                          .data([chart_data])                   
                          .attr("width", width)           
                          .attr("height", height)
                          .append("svg:g")                
                          .attr('transform', 'translate(' + (width / 2) +  ',' + (height / 1.5) + ')');    

              var arc = d3.arc()              
                        .innerRadius(radius * 0.4)         // This is the size of the donut hole
                        .outerRadius(radius * 0.7)
              
              var outerArc = d3.arc()
              .innerRadius(radius * 0.4)
              .outerRadius(radius * 1.85);
              var outerArc2 = d3.arc()
              .innerRadius(radius * 0.4)
              .outerRadius(radius * 1.35);
          
              var pie = d3.pie()           
                          .startAngle(-90 * (Math.PI/180))
                          .endAngle(90 * (Math.PI/180))
                          .padAngle(.01) 
                          .sort(null) 
                          .value(function(d) { return d.value; });    
                          
              var arcs = vis.selectAll("g.slice")     
                          .data(pie)  
                          .enter()   
                          .append("svg:g") 
                          .attr("class", "slice");    

                               
              var outerArcs = vis.selectAll("g.slice2")     
                          .data(pie)  
                          .enter()   
                          .append("svg:g") 
                          .attr("class", "slice");    
          
                  arcs.append("svg:path")
                          .attr("fill", function(d, i) { return color(i); } ) 
                          .attr("d", arc);                                  
                          
                      vis
                    .selectAll('allPolylines')
                    .data(pie)
                    .join('polyline')
                      .attr("stroke", function(d, i) { return color(i); } ) //, "#797979")
                      .style("fill", "none")
                      .attr("stroke-width", 1)
                      .attr('points', function(d) {
                        const posA = arc.centroid(d); 
                        const posB = outerArc2.centroid(d) ; 
                        return [posA, posB];
                      });
                      
                  outerArcs.append("svg:text")                                    
                          .attr("fill", "#000")
                          .attr("transform", function(d) {                    
                          d.innerRadius = 0;
                          d.outerRadius = radius;
                          return "translate(" + outerArc.centroid(d) + ")";        
                      })
                      .attr("text-anchor", "middle")                          
                      .attr("font-size", 10)
                      .attr("y", "-0.5em")  
                      .text(function(d, i) { return chart_data[i].label; });   
                                          
                      arcs.append("svg:text")
                      .attr("dy", ".01em")
                      .attr("text-anchor", "middle")
                      .attr("font-size",16)
                      .attr("fill","#000000")
                      .text(function(d, i) {
                        return that.master.jobCompletionPercent+"%";
                      });
                    
                  outerArcs.append("svg:text")                                     
                          .attr("fill", "#000")
                          .attr("transform", function(d) {                    
                          d.innerRadius = 0;
                          d.outerRadius = radius;
                          return "translate(" + outerArc.centroid(d) + ")";        
                      })
                      .attr("text-anchor", "middle")    
                      .attr("font-size", 12)
                      .attr("y", "1em")                       
                      .text(function(d, i) { return chart_data[i].value; });      

                      const tooltip = d3.select(div_id)
              .append("div")
              .style("opacity", 0)
              .attr("class", "tooltip")
              .style("background-color", "white")
              .style("border", "solid")
              .style("border-width", "1px")
              .style("border-radius", "5px")
              .style("padding", "10px");

              const mouseover = function(event, d) {
                const subgroupName = d.data.label;
                var table = "<b>"+"Overall Job Completion"+"</b><table>";
                const rows = _.map(data.chart_data, function(value, key) {
                    return "<tr>"
                      + "<td style='padding:2px;'>" 
                      + "<span style='background-color:"+color(value.label)+";'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>"
                      + "</td>"
                      + "<td style='padding:2px;'>" 
                      + (value.label==subgroupName ? "<b>"+value.label+"</b>" : value.label)
                      + "</td>"
                      + "<td style='padding:2px;text-align:right;'>"
                      + (value.label==subgroupName ? "<b>"+value.value+"</b>" : value.value)
                      + "</td>"
                      + "</tr>";
                });
                table += rows.join('');
                table += "</table>";
                tooltip
                    .html(table)
                    .style("opacity", 1);

              };
              const mousemove = function(event, d) {
                const [x, y] = d3.pointer(event);
                tooltip
                      .style("left",x+150+"px")
                      .style("top",y+60+"px");
              };
              const mouseleave = function(event, d) {
                tooltip
                  .style("opacity", 0)
              };

              arcs
                  .on("mouseover", mouseover)
                  .on("mousemove", mousemove)
                  .on("mouseleave", mouseleave);
        }
        else{
          this.showNoDataChart("#jobCompleteGaugeChart"+data.maintenance_program_id,data.height);
          return;
        }
      },
      showV3Card(id){
        const div = document.querySelector(id);
        let divV3 = div.closest('.v3-card');
        if(divV3)divV3.style.display = 'block';
      },
      showNoDataChart(id,height){
        //this.showMessage(id,height,'No data available');
      },
      showMessage(id,height,message){
        const div = document.querySelector(id);
        div.innerHTML = "<div class='div-message' style='min-height:"+height+"px;line-height:"+height+"px;'>"+message+"</div>";
      },
      showLoadingMessage(id,height,message){
        const div = document.querySelector(id);
        div.innerHTML = "<div class='div-message run-loading' style='min-height:"+height+"px;line-height:"+height+"px;'>"+message+"</div>";

      },
      loadVerticalStackBarChart(div_id,data, groupKey, subGroupKey){
        var yLabelName = '';
        if(subGroupKey=='job_status'){
          yLabelName = '# of PM Jobs';
        }
        else if(subGroupKey=='order_status'){
          yLabelName = '# of Work Orders';
          
        }
        else if(subGroupKey=='case_status'){
          yLabelName = '# of Cases';
        }
        
        if(data.original && data.original.length == 0){
          this.showNoDataChart(div_id,data.height);
          return;
        }
        
        var summary = _(data.original)
        .groupBy(x => x[groupKey])
        .map((value, key) => ({category: key, count: _.sumBy(value, function(o) { return o.count; })
        }))
        .value();

        var all_counts = 0;
        _.map(summary,function(o){all_counts+=o.count;});

        if(all_counts==0) return;
        
        this.showV3Card(div_id);

        var result = _(data.original)
            .groupBy(x => x[groupKey])
            .map((value, key) => ({category: key, data: value}))
            .value();

        var pivot_arr = [];
        result.forEach(x => { 
          var n = {};
          n.category = x.category;
          n.category_status = data.category_status[n.category];
          data.status.forEach(y=> {
            var obj_to_locate = { [subGroupKey]: y };
            const f = _.find(x.data, obj_to_locate);
            if(f){
              n[y] = f.count;
            }
            else{
              n[y] = 0;
            }
          });
          pivot_arr.push(n);

        });

        const div = document.querySelector(div_id);
        div.innerHTML = "";
        var div_width = window.innerWidth * 0.29;
          // set the dimensions and margins of the graph
          const margin = {top: 10, right: 10, bottom: 30, left: 60},
              width = div_width - margin.left - margin.right,
              height = data.height - margin.top - margin.bottom;

          // append the svg object to the body of the page
          const svg = d3.select(div_id)
            .append("svg")
              .attr("width", width + margin.left + margin.right)
              .attr("height", height + margin.top + margin.bottom)
              .append("g")
              .attr("transform", `translate(${margin.left},${margin.top})`);

            const subgroups = data.status;
            const groups = data.category;

            // Add X axis
            const x = d3.scaleBand()
                .domain(groups)
                .range([0, width])
                .padding([data.category.length == 1 ? 0.7 : 0.5])
            svg.append("g")
              .attr("transform", `translate(0, ${height})`)
              .call(d3.axisBottom(x).tickSizeOuter(0))
                .attr('font-size',9)
              .selectAll(".tick text")
              .call(this.wrap, x.bandwidth());

            var yMax = d3.max(pivot_arr, d => {
              var val = 0
              for(var k of subgroups){
                val += d[k]
              }
              return val;
            });
            yMax = yMax + (yMax * 0.1);

            // Add Y axis
            const y = d3.scaleLinear()
              .domain([0, yMax])
              .range([ height, 0 ]);
            svg.append("g")
              .call(d3.axisLeft(y).ticks(5))
              // Add label
              .append('text')
              .attr('class', 'axis-label')
              .text(yLabelName)
              .attr('transform', 'rotate(-90)')
              .attr('x', -(margin.top + (height - margin.top - margin.bottom) / 2))
              .attr('y', -40) // Relative to the y axis.;

            var color_range = [];
            for(var k of subgroups){
              color_range.push(this.pm1_chart_colors[k]);
            }

            const color = d3.scaleOrdinal()
              .domain(subgroups)
              .range(color_range);

            const stackedData = d3.stack()
              .keys(subgroups)
              (pivot_arr);
                        
            const tooltip = d3.select(div_id)
              .append("div")
              .style("opacity", 0)
              .attr("class", "tooltip")
              .style("background-color", "white")
              .style("border", "solid")
              .style("border-width", "1px")
              .style("border-radius", "5px")
              .style("padding", "10px")

            var that = this;
            const mouseover = function(event, d) {
              const subgroupName = d3.select(this.parentNode).datum().key;
              
              var table = "<b>"+d.data.category+"</b><table>";
              const rows = _.map(d.data, function(value, key) {
                if (key != "category"){
                  if(d.data.category_status.includes(key)){
                    return "<tr>"
                      + "<td  style='padding:2px;'>" 
                      + "<span style='background-color:"+that.pm1_chart_colors[key]+";'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>"
                      + "</td>"
                      + "<td style='padding:2px;'>" 
                      + (key==subgroupName ? "<b>"+key+"</b>" : key)
                      + "</td>"
                      + "<td style='padding:2px;text-align:right;'>"
                      + (key==subgroupName ? "<b>"+value+"</b>" : value)
                      + "</td>"
                      + "</tr>";
                  }
                }
                else
                return "";
              });
              table += rows.join('');
              table += "</table>";
              tooltip
                  .html(table)
                  .style("opacity", 1);

            };
            const mousemove = function(event, d) {
              const [x, y] = d3.pointer(event);
              tooltip.style("transform","translateY(-55%)")
                    .style("left",x+"px")
                    .style("top",y+"px");
            };
            const mouseleave = function(event, d) {
              tooltip
                .style("opacity", 0)
            };

            // Show the bars
            svg.append("g")
              .selectAll("g")
              .data(stackedData)
              .join("g")
                .attr("fill", d => color(d.key))
                .selectAll("rect")
                .data(d => d)
                .join("rect")
                  .style("opacity", 0)
                  .attr("x", d => x(d.data.category))
                  .attr("y", d => y(d[1]))
                  .attr("height", d => y(d[0]) - y(d[1]))
                  .attr("width",x.bandwidth())
                  .on("mouseover", mouseover)
                  .on("mousemove", mousemove)
                  .on("mouseleave", mouseleave);

              // Animation
              svg.selectAll("rect")
                .transition()
                .duration(800)
                .style("opacity", 1)
                .delay((d,i) => {return i*100})

              // Total
              svg.append("g")
                .selectAll("g")
                .data(summary)
                .join("text")
                .attr("x", d => x(d.category) + (x.bandwidth()/2))
                .attr("y", d => y(d.count) - 5)
                .attr("fill", "#000000")
                .attr('text-anchor', 'middle')
                .attr("transform", d => d.transform)
                .attr('font-size',11)
                .attr('font-family','sans-serif')
                .text(function(d) { 
                  return d.count; 
                })
                .style("opacity", 0)
                .transition()
                .duration(1000)
                .style("opacity", 1);      
      },
      loadHorizontalStackBarChart(div_id,data, groupKey, subGroupKey){
        
        if(data.original && data.original.length == 0){
          this.showNoDataChart(div_id,data.height);
          return;
        }
        this.showV3Card(div_id);

        var result = _(data.original)
            .groupBy(x => x[groupKey])
            .map((value, key) => ({category: key, data: value}))
            .value();

        var summary = _(data.original)
        .groupBy(x => x[groupKey])
        .map((value, key) => ({category: key, count: _.sumBy(value, function(o) { return o.count; })
        }))
        .value();

        var pivot_arr = [];
        result.forEach(x => { 
          var n = {};
          n.category = x.category;
          data.status.forEach(y=> {
            var obj_to_locate = { [subGroupKey]: y };
            const f = _.find(x.data, obj_to_locate);
            if(f){
              n[y] = f.count;
            }
            else{
              n[y] = 0;
            }
          });
          pivot_arr.push(n);
        });

        const div = document.querySelector(div_id);
        div.innerHTML = "";
        var div_width = window.innerWidth * 0.29;
          // set the dimensions and margins of the graph
          const margin = {top: 10, right: 10, bottom: 70, left: 130},
              width = div_width - margin.left - margin.right,
              height = data.height - margin.top - margin.bottom;

          // append the svg object to the body of the page
          const svg = d3.select(div_id)
            .append("svg")
              .attr("width", width + margin.left + margin.right)
              .attr("height", height + margin.top + margin.bottom)
              .append("g")
              .attr("transform", `translate(${margin.left},${margin.top})`);

            const subgroups = data.status;
            const groups = data.category;

            var xMax = d3.max(pivot_arr, d => {
              var val = 0
              for(var k of subgroups){
                val += d[k]
              }
              return val;
            });
            xMax = xMax + (xMax * 0.1);

            // Add X axis
            const x = d3.scaleLinear()
                .domain([0,xMax])
                .range([0, width]);

            svg.append("g")
              //.attr("transform", `translate(0, ${height})`)
              .attr("transform", `translate(0, ${height})`)
              .call(d3.axisBottom(x).tickSizeOuter(0).ticks(5))
              // Add label
              .append('text')
              .attr('class', 'axis-label')
              .text('# of PM Jobs')
              .attr('x', (width - margin.left - margin.right) / 2)
              .attr('y', 50) // Relative to the x axis.;


            // Add Y axis
            const y = d3.scaleBand()
              .domain(groups)
              .range([ 0, height ])
              .padding([data.category.length == 1 ? 0.5 : 0.4]);
            svg.append("g")
              .call(d3.axisLeft(y))
              .attr('font-size',9)
              .selectAll(".tick text")
              .call(this.wrapY, margin.left);

            var color_range = [];
            for(var k of subgroups){
              color_range.push(this.pm2_chart_colors[k]);
            }

            const color = d3.scaleOrdinal()
              .domain(subgroups)
              .range(color_range);

            const stackedData = d3.stack()
              .keys(subgroups)
              (pivot_arr);
       
            const tooltip = d3.select(div_id)
              .append("div")
              .style("opacity", 0)
              .attr("class", "tooltip")
              .style("background-color", "white")
              .style("border", "solid")
              .style("border-width", "1px")
              .style("border-radius", "5px")
              .style("padding", "10px")

            var that = this;
            const mouseover = function(event, d) {
              const subgroupName = d3.select(this.parentNode).datum().key;

              var table = "<b>"+d.data.category+"</b><table>";
              const rows = _.map(d.data, function(value, key) {
                if (key != "category"){
                  return "<tr>"
                    + "<td  style='padding:2px;'>" 
                    + "<span style='background-color:"+that.pm2_chart_colors[key]+";'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>"
                    + "</td>"
                    + "<td style='padding:2px;'>" 
                    + (key==subgroupName ? "<b>"+key+"</b>" : key)
                    + "</td>"
                    + "<td style='padding:2px;text-align:right;'>"
                    + (key==subgroupName ? "<b>"+value+"</b>" : value)
                    +"</td>"
                    + "</tr>";
                }
                else
                return "";
              });
              table += rows.join('');
              table += "</table>";
              tooltip
                  .html(table)
                  .style("opacity", 1);

            };
            const mousemove = function(event, d) {
              const [x, y] = d3.pointer(event);
              tooltip.style("transform","translateY(-55%)")
                    .style("left",x+"px")
                    .style("top",y+"px");

            };
            const mouseleave = function(event, d) {
              tooltip
                .style("opacity", 0)
            };

            // Show the bars
            svg.append("g")
              .selectAll("g")
              .data(stackedData)
              .join("g")
                .attr("fill", d => color(d.key))
                .selectAll("rect")
                .data(d => d)
                .join("rect")
                  .style("opacity", 0)
                  .attr("x", d => x(d[0]))
                  .attr("y", d => y(d.data.category))
                  .attr("width", d => x(d[1]) - x(d[0]))
                  .attr("height",y.bandwidth())
                  .on("mouseover", mouseover)
                  .on("mousemove", mousemove)
                  .on("mouseleave", mouseleave);

              // Animation
              svg.selectAll("rect")
                .transition()
                .duration(800)
                .style("opacity", 1)
                .delay((d,i) => {return i*100})

              // Total
              svg.append("g")
                .selectAll("g")
                .data(summary)
                .join("text")
                .attr("y", d => y(d.category) + (y.bandwidth()/2))
                .attr("x", d => x(d.count) + 15)
                .attr("fill", "#000000")
                .attr('text-anchor', 'middle')
                .attr("transform", d => d.transform)
                .attr('font-size',11)
                .attr('font-family','sans-serif')
                .text(function(d) { 
                  return d.count; 
                })
                .style("opacity", 0)
                .transition()
                .duration(1000)
                .style("opacity", 1);       
      },
     wrap(text, width) {
      var x=0;
      text.each(function() {
        var text = d3.select(this),
            words = text.text().trim().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = 0,
            lineHeight = 1.1, // ems
            y = text.attr("y"),
            dy = parseFloat(text.attr("dy")),
            tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
        while (word = words.pop()) {
          line.push(word);
          tspan.text(line.join(" "));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(" "));
            line = [word];
            tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
          }
        }
      });
    },
     wrapY(text, width) {
      var x=-6;
      var lineCount = 0;
      text.each(function() {
        var text = d3.select(this),
            words = text.text().trim().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = 0,
            lineHeight = 1.1, // ems
            y = text.attr("y"),
            dy = parseFloat(text.attr("dy")),
            tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
            lineCount = 1;
        while (word = words.pop()) {
          if(lineCount < 2){
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
              lineCount += 1;
            }
          }
        }
      });
    },
      loadPMJobsAssignjobCompletionBarChart3(data){
        var clabel = '';
        if(data.pm2_all_status_count[0].length==1){
          clabel = 'No data.';
          data.pm2_all_status_count = [];
        }

        var initial = [];
        data.pm2_all_status_count.forEach(arr => {
          var i = 0;
          var arr2= [];
          arr.forEach(item => {
            if(i==0) arr2.push(item);
            else arr2.push(0);
            i++;
          });
          initial.push(arr2);
        });

        this.charts.chart3 = c3.generate({
            bindto: '#jobCompletionBarChart3',
            size: {
              height: data.height
            },
            data: {
                columns: initial,
                order: null,
                type: 'bar',
                groups: [data.status],
                colors: this.pm2_chart_colors,
                labels: {
                    format: function (v, id, i, j) {
                        if (v == 0)
                            return "";
                        else
                            return v;
                    }
                },
            },
            axis: {
                rotated: true,
                x: {
                  type: 'category',
                  categories: data.category
                },
                y: {
                  label: { text: clabel,  position: 'inner-center' },                      
                  tick: {
                      format: function (d) {
                          return (parseInt(d) == d) ? d : null;
                      }
                  }
                }
            },
            legend: {
              show: false
            },
            tooltip: {
              position: function (data, width, height, element) {
                return {top: 0, left: 0};
              }
            },
            bar: {
              width: {
                ratio: data.category.length == 1 ? 0.2 : 0.4
              }
            }
        });

        setTimeout(function (chart,data) {
            chart.load({
                columns: data
            });
        }, 100,this.charts.chart3,data.pm2_all_status_count);  
      },
      loadOptionsService({ action, parentNode, callback,instanceId  }){
        if(parentNode.isBatch){
          if (action === LOAD_CHILDREN_OPTIONS ) {
              simulateAsyncOperation(async () => {
                  parentNode.children = await this.getDataService(parentNode.data.id,'all',false);
                  callback()
              })
          }
        }else{
            parentNode.children = undefined;
            callback()
        }
      },
      normalizerService(node) {
          if(node.data && !node.data.isBatch){
              return {
                  children : undefined,
                  label: node.name
              }
          }
          return {
              label: node.name
          }
      },
      async getDataService(parent_id,node_type,set = false){
          let data = [];
          await global.axios(`api/master/tree-service-categories/${parent_id}`, {
              method: "GET",
              headers: { Accept: "application/json", },
              params: {
                  node_type: node_type
              },
          })
              .then(response => {
                  data = response.data.data;
              }).catch(error => {
                  console.log(error);
              });
          if(set){
              this.dataService = data;
          }else{
              return data
          }
      },
      async checkToRedirectToSixMonthly(){
        var user_id = this.UserLogin.id;
            console.log('user_id',user_id);
            let params_detail = {
              user_id : user_id,
              contract_id : this.master.contract_id,
              service_category_name : "6 Monthly Safety Hazard Inspection"
            };
            await this.$store.dispatch(`UserDutyController/checkUserDutyServiceCategory`, params_detail)
                .then(result => {
                  if(result && result.length >0){
                    this.$router.push(`/v2/fm-dashboard-six-monthly-safety-hazard-inspection`);
                  }
                })
            .catch(error => {});
      },
    },
    watch: {
      ClientContractID: function(val, old){
          if(!val){
              this.$router.go();
          }
          else if((val && old && old.id && val.id !== old.id)||(!old && val)||(!old.id && val.id)){
            this.loadingData = true;
            this.master.contract_id = this.ClientContractID.id;
            this.master.contract_term_id = this.ClientContractID.contract_terms[0].id;
            this.checkToRedirectToSixMonthly();
            this.loadRootProperty();
          }
          else {
            this.loadingData = false;
          }
      }
    }
  }
</script>